<app-header></app-header>
<section class="terms-container" [ngStyle]="{'direction':lang==='ar' ? 'rtl' : 'ltr' }">
    <div class="container">
        <h3 class="first-ele">{{'terms-head-1'|translate}}</h3>
        <p> {{'terms-p-1'|translate}} </p>
        <h3>{{'terms-head-2'|translate}}</h3>
        <p> {{'terms-p-2'|translate}} </p>
        <h3>{{'terms-head-3'|translate}}</h3>
        <p> {{'terms-p-3'|translate}} </p>
        <h3>{{'terms-head-4'|translate}}</h3>
        <p> {{'terms-p-4'|translate}} <a routerLink="/privacyPolicy">{{'Privacy-Policy' |translate}}</a> </p>
        <h3>{{'terms-head-5'|translate}}</h3>
        <p> {{'terms-p-5'|translate}} </p>
        <h4>{{'terms-a-1'|translate}}</h4>
        <p>{{'terms-a-2'|translate}}</p>
        <p> {{'terms-a-3'|translate}}</p>
        <h4>{{'terms-b-1'|translate}}</h4>
        <p> {{'terms-b-2'|translate}}</p>
        <h4>{{'terms-c-1'|translate}}</h4>
        <p> {{'terms-c-2'|translate}}
            <a routerLink="/termsOfUse"> info@robogarden.ca</a>
        </p>
        <h4>{{'terms-d-1'|translate}}</h4>
        <p>{{'terms-d-2'|translate}}</p>
        <h3>{{'terms-head-6'|translate}}</h3>
        <p> {{'terms-p-6'|translate}} </p>
        <h3>{{'terms-head-7'|translate}}</h3>
        <p> {{'terms-p-7'|translate}} </p>
        <p>{{'terms-p-7-2'|translate}}v</p>
        <div>
            <ol>
                <li> {{'terms-li-1'|translate}} </li>
                <li> {{'terms-li-2'|translate}} </li>
                <li> {{'terms-li-3'|translate}} </li>
                <li> {{'terms-li-4'|translate}} </li>
                <li> {{'terms-li-5'|translate}} </li>
                <li> {{'terms-li-6'|translate}} </li>
                <li> {{'terms-li-7'|translate}} </li>
            </ol>
        </div>
        <p> {{'terms-ol-after-text'|translate}} </p>
        <div>
            <ol>
                <li>{{'terms-li-8'|translate}} </li>
                <li>{{'terms-li-9'|translate}} </li>
                <li>{{'terms-li-10'|translate}} </li>
                <li>{{'terms-li-11'|translate}} </li>
            </ol>
        </div>
        <h3>{{'terms-head-8'|translate}}</h3>
        <p> {{'terms-p-8'|translate}} </p>
        <h3>{{'terms-head-9'|translate}}</h3>
        <p> {{'terms-p-9'|translate}} </p>
        <h3>{{'terms-head-10'|translate}}</h3>
        <p> {{'terms-p-10'|translate}} </p>
        <h3>{{'terms-head-11'|translate}}</h3>
        <p> {{'terms-p-11'|translate}} </p>
        <h3>{{'terms-head-12'|translate}}</h3>
        <p> {{'terms-p-12'|translate}} </p>
        <p> {{'terms-p-12-2'|translate}} </p>
        <h3>{{'terms-head-13'|translate}}</h3>
        <p>  {{'terms-p-13'|translate}} </p>
        <h3>{{'terms-head-14'|translate}}</h3>
        <p> {{'terms-p-14'|translate}}  </p>
        <h3>{{'terms-head-15'|translate}}</h3>
        <p> {{'terms-p-15'|translate}} </p>
        <h3>{{'terms-head-16'|translate}}</h3>
        <p> {{'terms-p-16'|translate}} </p>
        <p class="last-p"> {{'terms-p-16-2'|translate}} </p>
    </div>
</section>
<app-subscribe></app-subscribe>

<app-footer></app-footer>